import { create } from "zustand"
import { persist, createJSONStorage } from "zustand/middleware"
import { TableSearchParams } from "../types/table"

interface TableState {
  states: Record<string, TableSearchParams>
  filterStates: Record<string, Record<string, unknown>>
  setTableState: (key: string, state: Partial<TableSearchParams>) => void
  getTableState: (key: string) => TableSearchParams | undefined
  setFilterState: (key: string, filters: Record<string, unknown>) => void
  getFilterState: (key: string) => Record<string, unknown> | undefined
  clearAllTableStates: () => void
}

export const useTableStateStore = create<TableState>()(
  persist(
    (set, get) => ({
      states: {},
      filterStates: {},
      setTableState: (key: string, state: Partial<TableSearchParams>) =>
        set((prev) => ({
          states: {
            ...prev.states,
            [key]: {
              ...(prev.states[key] || {}),
              ...state,
            },
          },
        })),
      getTableState: (key: string) => get().states[key],
      setFilterState: (key: string, filters: Record<string, unknown>) =>
        set((prev) => ({
          filterStates: {
            ...prev.filterStates,
            [key]: filters,
          },
        })),
      getFilterState: (key: string) => get().filterStates[key],
      clearAllTableStates: () => set({ states: {}, filterStates: {} }),
    }),
    {
      name: "table-state-storage",
      storage: createJSONStorage(() => localStorage),
    },
  ),
)
